import React from "react";
import * as s from "./OfflineLibraryTab.module.scss";
import {
  Button,
  Col,
  Container,
  DynamicImage,
  DynamicLink,
  P,
  Row,
} from "resource-centre-theme/src/views/shared/components";
import { inject, observer } from "mobx-react";
import { UIStore, CacheStore } from "resource-centre-theme/src/stores";
import { createMarkup, truncate } from "resource-centre-theme/src/libs/utils";
import { tx } from "resource-centre-theme/src/libs/i18n";
import { Icons } from "resource-centre-theme/src/libs/assets";
import { graphql, StaticQuery } from "gatsby";
import { ISettings } from "resource-centre-theme/src/models";

interface Props {
  uiStore?: UIStore;
  cacheStore?: CacheStore;
  settings: ISettings;
}

@inject("uiStore", "cacheStore")
@observer
export class OfflineLibraryTabComponent extends React.Component<Props> {
  componentDidMount() {
    const { cacheStore } = this.props;
    const { initCacheStore } = cacheStore;
    initCacheStore();
  }

  renderCachedDocument = (document, key) => {
    const { cacheStore } = this.props;
    const { deleteFromCache } = cacheStore;
    let image = null;
    let title = null;
    let meta = null;
    const isDesktop = this.props?.uiStore?.isDesktop;

    if (document.nodeType === "Document") {
      image = document.documentThumbnail?.image;
      title = document.title;

      meta = [
        document.documentFields?.publicationYear,
        document.documentPublishers?.publishers.length > 0 &&
          document.documentPublishers?.publishers[0]?.name,
      ]
        .filter((a) => !!a)
        .join(" · ");
    } else if (document.nodeType === "Article") {
      image = document?.articleFields?.imageGroup?.image;
      title = document?.articleFields?.title;
    }

    return (
      <Col xs={6} lg={3} key={`post_${key}`} className={s.postCardColumn}>
        <DynamicLink to={document.link} className={s.postCardLink}>
          <div className={s.postImage}>
            <DynamicImage image={image} size="mediumLarge" alt="card-image" />
            <div className={s.postImageOverlay}>
              <div className={s.overlayBottomRow}>
                <div
                  className={s.removeButton}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    deleteFromCache(document);
                  }}
                >
                  <img src={Icons.trash_small_white} />
                </div>
              </div>
            </div>
          </div>
          <div className={s.postTitleRow}>
            {title && (
              <p className={s.postTitle}>
                {truncate(title, isDesktop ? 75 : 20)}
              </p>
            )}
            <img className={s.moreIcon} src={Icons.more_large} />
          </div>
          {meta && (
            <P small className={s.publishingInformationLabel}>
              {meta}
            </P>
          )}
        </DynamicLink>
      </Col>
    );
  };

  renderDownloadLibButton = () => {
    const { toggleSidebar } = this.props?.cacheStore;

    return (
      <div className={s.download} onClick={toggleSidebar}>
        <P className={s.text}>{tx("offline.downloadLibrary")}</P>

        <img
          src={Icons.download_small}
          alt="download-icon"
          className={s.icon}
        />
      </div>
    );
  };

  render() {
    const { cacheStore, settings } = this.props;
    const { cacheResults, clearCache } = cacheStore;
    const { themeSettings } = settings;
    const { themeSettingsFields } = themeSettings;
    const { offlineLibraryUseInformation } = themeSettingsFields;

    return (
      <Container>
        <Row>
          <Col xs="12">
            <Col lg={"8 offset-lg-2"}>
              <div className={s.wysiwygContainer}>
                <div
                  className={s.wysiwyg}
                  dangerouslySetInnerHTML={createMarkup(
                    offlineLibraryUseInformation
                  )}
                />
                {this.renderDownloadLibButton()}
              </div>
            </Col>
          </Col>
        </Row>
        {cacheResults?.length > 0 && (
          <>
            <Row className={s.row}>
              {cacheResults?.map((item, key) => {
                return this.renderCachedDocument(item, key);
              })}
            </Row>
            <Row className={s.buttonRow}>
              <Button color="red" size="small" onClick={clearCache}>
                {tx("cache.deleteAllFromCache")}
              </Button>
            </Row>
          </>
        )}
        {cacheResults?.length == 0 && (
          <Row className={s.noResources}>
            <P>{tx("profile.noResources")}</P>
          </Row>
        )}
      </Container>
    );
  }
}

export const OfflineLibraryTab = (props: ISettings) => (
  <StaticQuery
    query={query}
    render={(data) => (
      <OfflineLibraryTabComponent {...props} settings={data.siteSettings} />
    )}
  />
);

const query = graphql`
  query {
    ...siteSettingsFragmentExtended
  }
`;
